<ps-ui-modal class="modal-container">
  <ps-ui-modal-title *ngIf="title">
    <h6 psUiModalTitle>
      {{ title }}
    </h6>
  </ps-ui-modal-title>
  <ps-ui-modal-body>
    <div *ngFor="let quota of quotas" class="modal-table-container">
      <h6>
        {{ getQualificationNameString(quota) }}
        <i
          class="fa fa-exclamation-circle me-2"
          aria-hidden="true"
          [ngClass]="{
            'warning-icon': modalType === 'difficult-quotas',
            'error-icon': modalType === 'impossible-quotas'
          }"
        ></i>
      </h6>
      <ps-ui-table [data]="[quota]">
        <ng-container psUiTableColumn title="Quota">
          <ng-template psUiTableCellTemplate let-item>
            <ng-container *ngFor="let criterion of item.criteria">
              <span class="criterion">
                {{ getConditionNameString(criterion) }}
              </span>
              <br />
            </ng-container>
          </ng-template>
        </ng-container>
        <ng-container psUiTableColumn title="Allocation">
          <ng-template psUiTableCellTemplate let-item>
            {{ item.required_count || item.number || 0 }}#
            {{ item.percentage | number : '1.0-0' }}%
          </ng-template>
        </ng-container>
        <ng-container psUiTableColumn title="MIN/MAX">
          <ng-template psUiTableCellTemplate let-item>
            {{ item.minimum }}/{{ item.maximum }}</ng-template
          >
        </ng-container>
      </ps-ui-table>
    </div>
    <div class="d-flex justify-content-center close-button">
      <button
        type="button"
        psUiButton
        color="primary"
        (click)="close()"
        class="btn-primary btn"
      >
        Close
      </button>
    </div>
  </ps-ui-modal-body>
</ps-ui-modal>
